<!--
 * @FileDescription: 应收应付（注释描述）
 * @Author: xy（作者）
 * @Date: 2020-07-20（时间）
 * @LastEditors: xy（最后更新人）
 * @LastEditTime: 2020-04-13（最后更新时间）
 -->
<template>
    <div class="page-container">
        <div class="page-container-height">
            <div class="inquire-module" id="page-top">
                <div class="inquire-module-left">
                    <a-input placeholder="请选择往来单位" v-model="inputValue"  @pressEnter="pressEnter()" @dblclick="pressEnter()" autoComplete="off" class="border-radius-input">
                        <a-tooltip slot="suffix" title="更多">
                            <div @click="pressEnter()">
                                <img src="@/assets/image/gengduo.png" alt="" style="width: 12px;" >
                            </div>
                        </a-tooltip>
                    </a-input>
                    <a-button @click="btnReset">重置</a-button>
                </div>
                <div>
                    <a-checkbox :checked="isCheck" @change="onChangeCheck">隐藏应收应付款均为零</a-checkbox>
                </div>
            </div>
            <div class="line"></div>
            <div class="choose-receipt-table">
                <a-table :columns="columns"
                         class="choose-table"
                         :dataSource="dataSource"
                         :pagination="pagination"
                         @change="handleTableChange"
                         :customRow="rowClick"
                         :scroll="{ y:'calc(100vh - 450px)' }"
                         bordered>
                    <template slot="operation"
                              slot-scope="text, record,index">
                        <span class="operator-span" @click="onDetail(record,3)">查看单据</span>
                        <span class="operator-span" @click="onDetail(record,1)" v-has="'finance_rarp_watch'">查看详情</span>
                        <span class="operator-span" @click="onDetail(record,2)" v-has="'finance_rarp_period_edit'">修改期初</span>
                    </template>
                    <template slot="footer">
                        <!--<a-table :columns="columns" :dataSource="footerDataSource" :pagination="false" :showHeader="false"  class="table-footer-detail"></a-table>-->
                        <div class="footer-total-amount">
                            <div class="footer-total-amount-left" style="width: 80px">
                                <span class="title">小计</span>
                            </div>
                            <div class="footer-total-amount-right" v-if="footerDataSource.length>0">
                                <span class="right-col">应收款金额：{{ footerDataSource[0].receivableAmount }}</span>
                                <span class="right-col">应付款金额：{{ footerDataSource[0].payableBalance }}</span>
                            </div>
                        </div>
                    </template>
                </a-table>
            </div>
            <receiptModel ref="receiptModel" @onSelectModel="onSelectModelReceipt"></receiptModel>
            <a-modal  v-model="isShowModel"  class="receipt-model1" :title="title"   @cancel="onCancel"  @ok="onCofrimForm" >
                <a-form :form="form"
                        :label-col="{ span: 9}"
                        :wrapper-col="{ span: 12 }" >
                    <a-form-item label="调整内容">
                        <a-select  v-decorator="['type',{ rules: [{ required: true,message:'请选定盘点仓库'}] },]"
                                   placeholder="请选择调整内容"
                        >
                            <a-select-option value="0">
                                调整应收款
                            </a-select-option>
                            <a-select-option value="1">
                                调整应付款
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="调整金额" style="display: flex">
                        <a-select  v-decorator="['status',{ rules: [{ required: true,message:'请选择调整内容'}] },]"
                                   class="rece-num-select"
                                   placeholder="请选择调整内容">
                            <a-select-option value="0">
                                调增
                            </a-select-option>
                            <a-select-option value="1">
                                调减
                            </a-select-option>
                        </a-select>
                        <a-input placeholder="请输入金额"
                                 typeof="number"
                                 class="rece-num-input"
                                 v-decorator="['amount', { rules: [{ required: true, message: '请输入金额' }] }]" />
                    </a-form-item>
                </a-form>
            </a-modal>
        </div>
    </div>
</template>
<script>
    import ACol from "ant-design-vue/es/grid/Col";
    import {mixins} from "@/mixins/mixins";
    import receiptModel from '@/components/receiptModel'
    import {finceorderPay,finceorderamount,financeTotalAmount} from "@/utils/api";
    export default {
        mixins:[mixins],
        components: {
            ACol,receiptModel
        },
        data () {
            return {
                isCheck:false,
                isShowModel:false,
                form: this.$form.createForm(this),
                inputValue:'',
                title:'调整应收应付款',
                columns: [
                    {
                        title: '',
                        dataIndex: '',
                        key: 'rowIndex',
                        width: 80,
                        align: "center",
                        customRender: function (text, r, index) {
                            return (text.rowIndex !== '合计') ? (parseInt(index) + 1) : text.rowIndex
                        }
                    },
                    {
                        title: '单位编号',
                        ellipsis: true,
                        dataIndex: 'contactCustomerCode',
                        key:'contactCustomerCode',
                    },
                    {
                        title: '单位名称',
                        ellipsis: true,
                        dataIndex: 'contactCustomerName',
                        key:'contactCustomerName',
                    },
                    {
                        title: '联系电话',
                        ellipsis: true,
                        dataIndex: 'mobile',
                        key:'mobile',
                    },
                    {
                        title: '应收款金额',
                        ellipsis: true,
                        dataIndex:'receivableAmount',
                        key:'receivableAmount',
                        align:'right',
                    },
                    {
                        title: '应付款金额',
                        ellipsis: true,
                        dataIndex:'payableBalance',
                        key:'payableBalance',
                        align:'right',
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        width:260,
                        align:'center',
                        scopedSlots: { customRender: 'operation' },
                    }
                ],
                dataSource: [],
                footerDataSource:[],
                recordItem:{},
                receivableAmount:'',
                payableBalance:'',
            }
        },
        mounted () {
            this.getList('')
            this.getAmount('')
        },
        watch:{
            pageList: {
                handler(newValue, oldValue) {
                    if(!this.isEmpty(newValue.result)){
                        this.dataSource = newValue.result.records
                        this.pagination.current = newValue.result.current
                        this.pagination.total =newValue.result.total
                        this.pagination.pageSize = newValue.result.size
                        this.pages = this.pageList.result.pages
                        this.loading = false
                        this.$store.state.isLoding = false
                    }
                },
                deep: true
            },
        },
        methods: {
            /** 表格增加合计行 */
            tableAddTotalRow (columns, dataSource) {
                this.footerDataSource = []
                let numKey = 'rowIndex'
                let totalRow = { [numKey]: '合计' }
                columns.forEach(column => {
                    let { key, dataIndex } = column
                    if(dataIndex == 'receivableAmount' ){
                        totalRow[dataIndex] = this.receivableAmount
                    }
                    if(dataIndex == 'payableBalance' ){
                        totalRow[dataIndex] = this.payableBalance
                    }
                })
                this.footerDataSource.push(totalRow)
            },
            getAmount(value){
                this.receivableAmount = ''
                this.payableBalance = ''
                let data = {
                    companyStoreId: this.$store.state.shopId,
                    companyId : this.$store.state.companyId,
                    contactCustomerId:value,
                    displayZero: this.isCheck ? 0 : 1,
                }
                data = this.$qs.stringify(data)
                financeTotalAmount(data,{}).then((res)=>{
                    if(res.success){
                        this.payableBalance = res.result.totalPayableBalance
                        this.receivableAmount = res.result.totalReceivableAmount
                        this.tableAddTotalRow(this.columns, this.dataSource)
                    }
                })

            },
            btnReset(){
              this.inputValue = ''
              this.getList('')
            },
            getList(value){
                this.$store.state.isLoding = true
                this.getPageList('/finance/api/financeReceivablePayable/ListFinanceReceivablePayable',
                        {
                            companyStoreId: this.$store.state.shopId,
                            companyId : this.$store.state.companyId,
                            contactCustomerId:value,
                            displayZero: this.isCheck ? 0 : 1,
                            keyWord:'',
                            pageNo : this.pagination.current,
                            pageSize : this.pagination.pageSize
                        },{
                            'Content-Type':'application/json'
                        },{})

            },
            onChangeCheck(e){
                this.isCheck = e.target.checked
                this.getList('')
                this.getAmount('')
            },
            onDetail(record,index){
                if(index == 1){
                    this.$router.push('/finance/financedata/receiptPaymentDetail?id='+record.id +'&name='+record.contactCustomerName)
                } else if(index == 2) {
                    this.form = this.$form.createForm(this)
                    this.isShowModel = true
                    this.recordItem = record
                } else {
                    this.$router.push({name: "已过账单据", params:{id: record.contactCustomerId, name: record.contactCustomerName}})
                }
            },
            rowClick(record, index){
                return {
                    on: {
                        dblclick:()=>{
                            this.$router.push('/finance/financedata/receiptPaymentDetail?id='+record.id +'&name='+record.contactCustomerName)
                        }
                    }
                }
            },
            /**
             * @description: 分页（方法描述）
             */
            handleTableChange(pagination, filters, sorter){
                this.pagination.current = pagination.current
                this.pagination.pageSize = pagination.pageSize
                this.getList('')
                this.getAmount('')
            },
            /**
             * @description: 往来单位（方法描述）
             */
            pressEnter(){
                this.$refs.receiptModel.onOpen(this.inputValue)
            },
            onCancel(){
                this.isShowModel = false
            },

            onCofrimForm(){
                this.form.validateFields((err, values) => {
                    if (!err) {
                        values.id = this.recordItem.id
                        values =   this.$qs.stringify(values)
                        finceorderamount(values,{}).then((res)=>{
                            if(res.success){
                                this.isShowModel = false
                                this.$message.success(res.logMessage)
                                this.getList('')
                                this.getAmount('')
                            }else{
                                this.$message.warn(res.logMessage)
                            }
                        })
                    }else{
                        this.$message.warn('您还有必填数据没有填写哦~')
                    }
                })
            },

            /**
             * @description: 往来单位回调（方法描述）
             */
            onSelectModelReceipt(record){
              console.log(record)
                this.isEvent = true
                this.inputValue = record.contactCustomerName
                // if(!this.isEmpty(record.contactCustomerName)){
                //
                // }else{
                //     this.inputValue = record.contactName
                // }
                this.getList(record.id)
                this.getAmount(record.id)
            }
        }
    }
</script>
<style lang="scss">
    .receipt-model1{
        width: 640px !important;
        height: 360px !important;
    }
    .border-radius-input{
        width:300px;
    }
    .choose-receipt-table{
        .choose-table{
            .ant-table{
                height: calc(100vh - 340px);
                overflow: hidden;
            }
            .ant-table-body{
                max-height: calc(100vh - 450px) !important;
            }
            .ant-table-wrapper {
                padding: 0;
            }
        }
        .ant-table-thead {
            tr {
                th {
                    height: 50px;
                    padding: 0 16px !important;
                }
            }
        }
        .ant-table-tbody {
            tr {
                .ant-input {
                    border-radius: 0 !important;
                }
                .blank-input {
                    width: 100%;
                    height: 54px;
                }
            }
        }
        .ant-table-footer {
            padding: 0 5px 0 0;
            td:last-child {
                border-right: 0 !important;
            }
            .ant-table-body {
                border: 0;
            }
            .ant-table-tbody > tr > td:nth-child(1),
            .ant-table-tbody > tr > td:nth-child(5),
            .ant-table-tbody > tr > td:nth-child(6){
                color: #333333;
                font-weight: 700;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .rece-num-select{
        width: 100px !important;
    }
    .rece-num-input{
        width: 180px !important;
        margin-left: 15px;
    }
    .page-container-height {
        background-color: #fff;
        .inquire-module {
            padding: 20px 30px 20px 30px;
            background-color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .inquire-module-left{
                display: flex;
                button{
                    margin-left: 20px;
                }
            }
        }
        .choose-receipt-table {
            .table-name{
                display: inline-block;
                width: 100%;
                height: 40px;
                line-height: 40px;
            }
            .table-name1{
                display: inline-block;
                width: 100%;
                height: 40px;
                line-height: 40px;
                padding: 0 11px;
            }
            .operator-span{
                cursor: pointer;
                color: #387BFC;
                margin-right: 20px;
            }
            .operator-span:last-child{
                margin-right: 0;

            }

        }
    }
</style>
